import ErrorScreen from '../../common/components/ErrorScreen';

function NotFoundPage() {
  return (
    <ErrorScreen
      title="Something's wrong here"
      message="This is a 404 error which means either you've clicked on a bad link or entered an invalid URL."
      variant="not-found"
    />
  );
}

export default NotFoundPage;
